export default __webpack_public_path__ + "static/media/hero-b.e076b3a1.jpg";